import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/statement-negative.svg";
var StatementNegativeSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  StatementNegativeSolid_default as default
};
